import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { SearchItem } from '@rivethealth/data/ui-search-item';
import { AnchoredPosition } from '../callout/callout-position';

type State = 'editing' | 'removing';

enum Key {
  BACKSPACE = 'Backspace',
  ENTER = 'Enter',
}

export type Chip = SearchItem & {
  invalid?: boolean;
};

@Component({
  selector: 'chip-input',
  styleUrls: ['./chip-input.component.scss'],
  templateUrl: './chip-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipInputComponent {
  constructor() {}
  @Input() up: boolean = false;

  @Input() chips: Chip[] = [];

  @Input() placeholder: string;

  @Input() search: (term: string) => Promise<SearchItem[]>;

  @Input() isValid: (chip: Chip) => boolean = () => true;

  @Output() rvChange = new EventEmitter<SearchItem[]>();

  @ViewChild('input', { static: false }) inputView: ElementRef;

  @Input() label: string;

  @Input() help: string;

  @Input() required: boolean;

  @Input() autocompletePreferredPosition = AnchoredPosition.BOTTOM_RIGHT;

  @Input() bordered = false;

  @Input() disabled = false;

  searchTerm = '';

  state: State = 'editing';

  remove(index: number) {
    this.rvChange.emit(this.chips.filter((_, i) => i != index));
    this.inputView.nativeElement.focus();
  }

  add(chips: Chip[]) {
    this.rvChange.emit([...this.chips, ...chips]);
    this.inputView.nativeElement.focus();
    this.searchTerm = '';
  }

  addBad(chip: SearchItem) {
    const chips =
      chip.description == null
        ? chip.text.split(' ').map(text => <SearchItem>{ text: text })
        : [chip];
    this.add(chips.map(chip => ({ ...chip, invalid: !this.isValid(chip) })));
  }

  keyDown(event: KeyboardEvent) {
    switch (this.state) {
      case 'editing':
        if (event.key == Key.BACKSPACE && this.searchTerm == '') {
          this.state = 'removing';
        }
        if (event.key == Key.ENTER && this.searchTerm != '') {
          event.stopPropagation();
          event.preventDefault();
        }
        break;
      case 'removing':
        if (event.key == Key.BACKSPACE) {
          this.remove(this.chips.length - 1);
        } else {
          this.state = 'editing';
        }
        break;
    }
  }

  blur() {
    if (!this.searchTerm) {
      return;
    }
    this.searchTerm = '';
  }
}
